import ManagementCompany from '@/services/api/managementCompany';

export default {
  namespaced: true,
  state: {
    managementCompanies: [],
    managementCompany: {},
  },
  getters: {
    managementCompanies: state => state.managementCompanies,
    managementCompany: state => state.managementCompany,
  },
  mutations: {
    setManagementCompanies: (state, payload) => {
      state.managementCompanies = payload;
    },
    setManagementCompany: (state, payload) => {
      state.managementCompany = payload;
    },
  },
  actions: {
    getManagementCompanies (state, options = {}) {
      return new Promise((resolve, reject) => {
        ManagementCompany.getManagementCompanies(options)
          .then(({ data }) => {
            state.commit('setManagementCompanies', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getManagementCompany (state, id) {
      return new Promise((resolve, reject) => {
        ManagementCompany.getManagementCompany(id)
          .then(({ data }) => {
            state.commit('setManagementCompany', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    createManagementCompany (state, params) {
      return new Promise((resolve, reject) => {
        ManagementCompany.createManagementCompany({ ...params })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateManagementCompany (state, { id, data }) {
      return new Promise((resolve, reject) => {
        ManagementCompany.updateManagementCompany(id, data)
          .then(({ data }) => {
            state.commit('setManagementCompany', data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    deleteManagementCompany (state, id) {
      return new Promise((resolve, reject) => {
        ManagementCompany.deleteManagementCompany(id)
          .then((response) => {
            resolve(response);
          })
          .catch(error => reject(error));
      });
    },
  },
};
